<template>
    <tr v-if="noDescription" class="budget-row-child">
        <td>{{ name }}</td>
        <Cell 
            v-for="(budget, index) in totals" 
            :budget="budget" 
            :key="index + name"
        />
    </tr>
    <RowDescription v-else
        :name="name" 
        :totals="totals" 
        :description="child.inc_change_descr" 
    />
</template>

<script>
    import RowDescription from '@/components/RowDescription';
    import Cell from '@/components/Cell';

    export default {
        name: 'RowChild',
        props: {
            'child' : Object, 
            'years' : Array
        },
        components: {
            RowDescription,
            Cell
        },
        computed: {
            name: function() {
                return this.child.programname || this.child.revenuesourcename || this.child.icchange_name || 'No Name'
            },
            totals: function() {
                let totals = {};

                for (const key in this.years) {
                    let year = this.years[key];
                    totals[year] = Number(this.child[year]) || 0;
                }
                return totals;
            },
            noDescription: function() {
                return (!this.child.inc_change_descr) ? true : false;
            }
        },
        mounted: function() {
            this.rollUpBudget(this.child);
        }, 
        methods: {
            rollUpBudget() { /* Send budget items to parent */
                this.$emit('totalUpdate', this.totals);
            }
        }
    }
</script>

